export default __webpack_public_path__ + "media/images/admin/account-d67747e2894a5966e3e7d362dbf8ed88.svg";